export default __webpack_public_path__ + "static/media/320-50.ef326e04.png";